import { Link } from "react-router-dom";
import { FOOTER_LINKS, SOCIALS, LOCATION } from "../data/content";

export const Footer = () => (
  <footer className="relative bg-ink text-cream" data-testid="site-footer">
    <div className="mx-auto max-w-[1600px] px-5 py-16 md:px-10 md:py-24">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-6">
          <h2 className="text-[9vw] font-medium uppercase leading-[0.82] tracking-tighter md:text-[4.2vw]">
            Greenwich
            <br />
            Village Baths
          </h2>
          <p className="mt-8 max-w-sm text-sm font-normal leading-relaxed text-cream/70">
            {LOCATION.address1}, {LOCATION.address2}. A family business, in the same place, since 1973.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="mb-6 text-xs uppercase tracking-[0.2em] text-cream/50">Site</p>
          <ul className="space-y-3">
            {FOOTER_LINKS.map((l) => {
              const testId = `footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`;
              const cls = "text-sm text-cream/80 transition-colors duration-300 hover:text-terracotta";
              return (
                <li key={l.label}>
                  {l.href ? (
                    <a href={l.href} data-testid={testId} className={cls}>
                      {l.label}
                    </a>
                  ) : (
                    <Link to={l.to} data-testid={testId} className={cls}>
                      {l.label}
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="mb-6 text-xs uppercase tracking-[0.2em] text-cream/50">Elsewhere</p>
          <ul className="space-y-3">
            {SOCIALS.map((s) => (
              <li key={s.label}>
                <a
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm text-cream/80 transition-colors duration-300 hover:text-terracotta"
                >
                  {s.label}
                </a>
              </li>
            ))}
            <li>
              <a
                href={`mailto:${LOCATION.email}`}
                className="text-sm text-cream/80 transition-colors duration-300 hover:text-terracotta"
              >
                {LOCATION.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-20 flex flex-col items-start justify-between gap-6 border-t border-cream/20 pt-8 md:flex-row md:items-center">
        <div className="flex items-center gap-4">
          <img
            src="/gvb-logo-cream.png"
            alt="Greenwich Village Baths — Since 1973"
            data-testid="footer-gvb-logo"
            className="h-24 w-auto md:h-28"
          />
        </div>
        <p className="text-xs uppercase tracking-[0.15em] text-cream/40">
          © {new Date().getFullYear()} Greenwich Village Baths
        </p>
      </div>
    </div>
  </footer>
);
